import React, { Component } from "react";
import { UserContext } from "../../Context";

import Button from "@atlaskit/button";

import ProfileBtnMenu from "../profileBtnMenu/ProfileBtnMenu";
import "./profileBtn.css";

export default class ProfileBtn extends Component {
  render() {
    return (
      <UserContext.Consumer>
        {userContext => {
          return (
            <div className="header__profile-btn">
              {(!!userContext.userLoading ||
                (!userContext.userLoading && !userContext.user)) && (
                <Button
                  isDisabled={userContext.userLoading}
                  isLoading={userContext.userLoading}
                  onClick={
                    userContext.user
                      ? this.logout
                      : userContext.loginModalHandler
                  }
                >
                  {userContext.user ? "Logout" : "Login"}
                </Button>
              )}
              {!userContext.userLoading &&
                !!userContext.user && <ProfileBtnMenu />}
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profileBtn/ProfileBtn.js